<template>
    <div>
        <div :class="'icon-select-container ' + 'icon-select-' + size">
            <div @click="selected(item)" :class="itemClass(item)" v-for="item in options">
                <span class="material-icons">{{ item[bindings.icon] }}</span>
                <span v-if="!hideLabels" class="icon-select-item-label">{{ item[bindings.label] }}</span>
                <ui-tooltip v-else>{{ item[bindings.label] }}</ui-tooltip>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .icon-select-container {
        margin-bottom: 1rem;

        .icon-select-item {
            user-select: none;
            display: inline-block;
            border-top: 1px solid #ddd;
            border-bottom: 1px solid #ddd;
            border-left: 1px solid #ddd;
            border-right: none;
            padding: 3px 10px 4px;

            cursor: pointer;

            &:last-of-type { border-right: 1px solid #ddd; border-top-right-radius: 3px; border-bottom-right-radius: 3px; }
            &:first-of-type {  border-left: 1px solid #ddd; border-top-left-radius: 3px; border-bottom-left-radius: 3px; }

            .material-icons { vertical-align: middle;  }
            .icon-select-item-label { line-height: normal; margin-left: 3px; }
            .material-icons { font-size: 1rem; }

            &:hover {
                border-color: #ccc;
                background: #fafafa;
            }

            &.icon-select-item-active {
                 border-right: 1px solid #ddd;
                border-color: #2196f3;
                background: #e1f2ff;
                color: #2196f3;
            }
        }

        &.icon-select-large { font-size: 1rem; }

        .icon-select-item.icon-select-item-active + .icon-select-item {
            border-left: none;
        }
    }
</style>

<script>
    export default {
        props: {
            value: { /**/ },
            hideLabels: {
                type: Boolean,
                default: false
            },
            options: {
                type: Array,
                required: true
            },
            bindings: {
                type: Object,
                default() {
                    return {
                        value: 'value',
                        icon: 'icon',
                        label: 'label',
                    }
                }
            },
            size: {
                type: String,
                default: 'normal'
            }
        },
        created() {
            this.internalValue = this.value
        },
        watch: {
            value(n, o) {
                if (n !== o) {
                    this.internalValue = n
                }
            }
        },
        data() {
            return {
                internalValue: null
            }
        },
        methods: {
            selected: _.debounce(function(item) {
                this.internalValue = item[this.bindings.value]
                this.$emit('input', this.internalValue)
            }),
            itemClass(item) {
                let str = 'icon-select-item'

                if (item.value === this.internalValue) {
                    str += ' icon-select-item-active'
                }

                return str
            }
        }
    }
</script>